<template>
<div class="m-auto float-left qrcode">

	<div v-if="alertVisible" class="alert d-flex align-items-center justify-content-between" :class="isAlertSuccess ? 'alert-success' : 'alert-danger'">
		<div>
			<i class="mr-2 fa" :class="isAlertSuccess ? 'fa-check' : 'fa-exclamation-triangle'"></i>
			{{alertMessage}}
		</div>
		<button type="button" class="close" aria-label="Close" v-on:click="alertVisible = false">
			<i class="fa fa-times fa-xs"></i>
		</button>
	</div>

	<div v-if="!hideButtons" class="buttons" :style="{'width': codeSize.width+'px'}">
		<i class="fas fa-copy icon-button text-white ml-3" v-on:click="copyImage"></i>
		<i class="fas fa-download icon-button text-white ml-3" v-on:click="saveImage"></i>
	</div>

	<div ref="printContent">

		<div :style="{'width': codeSize.width+'px', 'height': codeSize.height+'px'}">

			<div :id="'qrcode_'+rand" ref="qrcode" class="position-absolute"></div>

			<img
				v-if="logoUrl"
				ref="logoImage"
				:src="logoUrl"
				class="logo-image"
				:class="logoClasses"
				v-on:load="setLogoSize">
		</div>

		<div class="text-right mt-1" :style="{'width': codeSize.width+'px'}">
			<span v-if="title" v-html="title"></span>
		</div>

	</div>

</div>

</template>
<script type="text/javascript">

import html2canvas from 'html2canvas'

export default {
	name: "VueQrCode",
	components: {

	},
	props: [
		'params',
		'logoUrl',
		'logoClasses',
		'title',
		'hideButtons'
	],
	data() {
		return {
			rand: null,
			alertVisible: false,
			isAlertSuccess: false,
			alertMessage: ""
		}
	},
	computed: {
		codeStyle() {
			return {'width': this.codeSize.width+'px', 'height': this.codeSize.height+'px'}
		},
		codeSize() {
			let width = 256    // default width
			let height = 256   // default height

			if (this.params) {
				if ('width' in this.params && this.params.width)
					width = this.params.width
				if ('height' in this.params && this.params.height)
					height = this.params.height
			}

			return {width, height}
		},
		level() {
			const validCodes = ['L','M','Q','H']
			if (this.params && 'codeLevel' in this.params && validCodes.includes(this.params.codeLevel))
				return this.params.codeLevel
			return 'H'  // default level
		}
	},
	watch: {
		params() {
			if (typeof QRCode != 'undefined') {
				this.initQrCode()
			}
		}
	},
	methods: {
		copyImage() {
			const el = this.$refs.printContent;

			const options = {
				type: "dataURL"
			};

			html2canvas(el, options).then(canvas => {

				try {
					canvas.toBlob((blob) => {
						navigator.clipboard.write([
							new ClipboardItem({
								'image/png': blob
							})
						])
						this.alertMessage = "Copied to clipboard"
						this.isAlertSuccess = true
						this.alertVisible = true
					})

				} catch (e) {
					this.alertMessage = "Unable to copy QR code"
					this.isAlertSuccess = false
					this.alertVisible = true
				}
			})
		},
		saveImage() {
			const el = this.$refs.printContent;

			const options = {
				type: "dataURL"
			};

			html2canvas(el, options).then(canvas => {

				const link = document.createElement("a");
				link.setAttribute("download", "QR_Code.png");
				link.setAttribute(
					"href",
					canvas
						.toDataURL("image/png")
						.replace("image/png", "image/octet-stream")
				);
				link.click();
			})
		},
		setLogoSize() {

			let imageRef = this.$refs.logoImage
			const hwRatio = imageRef.height / imageRef.width
			const isVeryWide = (hwRatio < 0.2)

			// How much redundancy (in terms of a ratio of the overall area) does the QR code have?
			const levelRedundancy = {
				L: isVeryWide ? 0.14 : 0.07,   // fine-tune for better visuals
				M: isVeryWide ? 0.20 : 0.15,   // fine-tune for better visuals
				Q: 0.25,
				H: 0.30
			}

			// How much redundancy are we saving for wear-and-tear?  Higher for Q- and H-level codes because
			// they are more likely to be used in an outdoors setting, and suffer from additional damage
			const levelSafety = {
				L: 0.04,
				M: 0.08,
				Q: 0.16,
				H: 0.22
			}

			let levelRedundancyValue = levelRedundancy[this.level]
			let maxRedundancyRatio = levelRedundancyValue - levelSafety[this.level]

			// If the image is very wide then it takes up less vertical space, so we can save less room for wear-and-tear
			if (hwRatio < 0.25)
				maxRedundancyRatio = levelRedundancyValue - (levelSafety[this.level] / 6)

			const maxImageArea = (this.codeSize.height * this.codeSize.width) * maxRedundancyRatio
			const maxLength = Math.round(Math.sqrt(maxImageArea))

			imageRef.style.maxWidth = maxLength + "px"
			imageRef.style.maxHeight = maxLength + "px"
		},
		initQrCode() {
			if (typeof QRCode != 'undefined') {
				this.alertVisible = false
				this.$refs.qrcode.innerHTML = ""

				let fullParams = {...this.params}
				if (this.level in QRCode.CorrectLevel)
					fullParams.correctLevel = QRCode.CorrectLevel[this.level]
				let qrcode = new QRCode('qrcode_'+this.rand, fullParams)

				this.setLogoSize()
			}
		}
	},
	mounted() {

		this.rand = Math.floor(Math.random() * 10000000);

		let vm = this
		const recaptchaScript = document.createElement("script");
		recaptchaScript.setAttribute(
			"src",
			"https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js"
		);
		document.head.appendChild(recaptchaScript);

		let scriptLoadedChecker = setInterval(() => {
			if (typeof QRCode != 'undefined') {
				vm.initQrCode()
				clearInterval(scriptLoadedChecker)
			}
		},200)
	}
}
</script>

<style type="text/css" scoped>

.logo-image {
	position: relative;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	width: auto;
	height: auto;
	display: block;
	background-color: white;
}

.buttons {
	position: absolute;
	display: none;
	background-color: rgba(0,0,0,0.5);
	padding: 4px;
	text-align: right;
	z-index: 5;
}

.qrcode:hover .buttons {
	display: block;
}

</style>
